import React, {useState, useEffect, useRef} from 'react'

import classes from './PopupMinigameStars.module.css'
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import clsx from 'clsx';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Minigame from '@/js/Minigames/Minigame';
import Star from '@/components/shared/Star/Star';
import ActivityLogoName from '@/components/shared/ActivityLogoName/ActivityLogoName';
import SoundPlayer from 'react-sdk/SoundPlayer';
import CountUp from 'react-countup';


const PopupMinigameStars = () => {


  /** @type {Minigame} */
  let mg = PopupsManager.getData(POPUPS.MINIGAME_STARS)
  
  function handleClick() {
    PopupsManager.close(POPUPS.MINIGAME_STARS)
  }

  return (

    <Popup className={classes.PopupMinigameStars}>

      <ActivityLogoName mg={mg} />

      <div className={classes.score_title}>Score total</div>
      <div className={classes.stars_cntr}>
         <CountUp className={classes.star_count} end={mg.getStars()} duration={2} />
         <div className={classes.star}><Star /></div>
      </div>

      <div className={classes.btn}>
        <Button onClick={handleClick} >Continuer</Button>
      </div>


    </Popup>
  );
};

export default PopupMinigameStars;
